<script>
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import set from 'lodash/set';
import { computed, defineComponent, ref, toRefs, onBeforeUnmount, provide, watch } from 'vue';
import { normalizeChildren } from '@/shared/legacy/lib/util/component-helpers';
import { registerSymbol, getFieldDefaultValueSymbol } from './symbols';

export default defineComponent({
  name: 'FilterStateProvider',
  props: {
    defaultState: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['change'],
  setup(props, { emit }) {
    const { defaultState } = toRefs(props);
    const fields = ref({});
    const values = computed(() => {
      const fieldMap = Object.entries(fields.value);
      if (!fieldMap.length) {
        return null;
      }
      return fieldMap.reduce((result, [name, { getValue }]) => {
        set(result, name, getValue());
        return result;
      }, {});
    });

    const isSomeFieldVisible = computed(() => {
      return Object.values(fields.value).some(({ getIsInvisible }) => !getIsInvisible());
    });

    const computedState = computed(() => {
      return values.value || defaultState.value;
    });

    watch(computedState, (values, oldValue) => {
      if (!isEqual(values, defaultState.value) || isEqual(oldValue, values)) {
        emit('change', values);
      }
    });

    const getFieldDefaultValue = (name) => {
      return get(defaultState.value, name);
    };

    const register = (name, field) => {
      fields.value[name] = field;
      return () => {
        unregister(name);
      };
    };
    function unregister(name) {
      delete fields.value[name];
    }

    onBeforeUnmount(() => {
      fields.value = {};
    });

    provide(registerSymbol, register);
    provide(getFieldDefaultValueSymbol, getFieldDefaultValue);

    return {
      state: computedState,
      isSomeFieldVisible
    };
  },
  render() {
    const children = normalizeChildren(this, {
      state: this.state,
      isSomeFieldVisible: this.isSomeFieldVisible
    });
    return children[0];
  }
});
</script>

<i18n lang="json">{}</i18n>
